import { render, staticRenderFns } from "./comp_BookEditorInput-Image-CropperDialog.vue?vue&type=template&id=5586ba75&scoped=true&"
import script from "./comp_BookEditorInput-Image-CropperDialog.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorInput-Image-CropperDialog.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorInput-Image-CropperDialog.vue?vue&type=style&index=0&id=5586ba75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586ba75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
